import { render, staticRenderFns } from "./PeoplePerson.vue?vue&type=template&id=8c01b31e&"
import script from "./PeoplePerson.vue?vue&type=script&lang=js&"
export * from "./PeoplePerson.vue?vue&type=script&lang=js&"
import style0 from "./PeoplePerson.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports